<template>
    <div>
        <div v-if="chatOpen" class="chat-container">
            <chat :data="chatData" v-on:closeChat="chatOpen = false" />
        </div>
        <div class="navigator-panel" v-if="slick">
            <div class="navigator-btn-container navigator-btn-container-left">
                <transition name="swing-right">
                    <div class="navigator-btn navigator-btn-left"
                         v-on:click="goBack"
                         v-if="currentSlide > 0"
                         key="nav-left"
                         aria-label="Forrige slide"
                    >
                        <no-drag-image src="@/assets/btn-navigation-left.png" aria-label="Forrige slide"/>
                    </div>
                </transition>
            </div>
            <div class="navigator-btn-container navigator-btn-container-center">
                <div class="navigator-btn navigator-btn-center" :class="currentSlideText ? '' : 'navigator-btn-disabled'" v-on:click="togglePlay" :aria-label="playing ? 'Stop' : 'Læs op'">
                    <no-drag-image src="@/assets/btn-audio-play.png" v-if="!playing" aria-label="Læs op" />
                    <no-drag-image src="@/assets/btn-audio-stop.png" v-if="playing" aria-label="Stop" />
                </div>
                <label class="navigator-btn-label" v-text="playing ? 'Stop' : 'Læs op'" />
            </div>
            <div class="navigator-btn-container navigator-btn-container-right">
                <transition name="swing-left" mode="out-in">
                    <div class="navigator-btn navigator-btn-right"
                         v-on:click="goForward"
                         v-if="currentSlide < (slideCount - 1)"
                         key="nav-right"
                         aria-label="Næste slide"
                    >
                        <no-drag-image src="@/assets/btn-navigation-right.png" aria-label="Næste slide"/>
                    </div>
                    <div class="navigator-btn navigator-btn-right heartbeat"
                         v-on:click="openChatbot"
                         v-if="chatData && currentSlide === (slideCount - 1)"
                         key="chatbot"
                         aria-label="Åben quiz"
                    >
                        <no-drag-image src="@/assets/btn-chatbot.png" aria-label="Åben quiz"/>
                    </div>
                </transition>
                <label v-if="chatData && currentSlide === (slideCount - 1)" class="navigator-btn-label navigator-btn-label-quiz">Quiz</label>
            </div>
        </div>
    </div>
</template>

<script>
    import Chat from "./components/chat/Chat.vue";
    import NoDragImage from "./sgi/common/NoDragImage.vue";
    import {Howl} from 'howler';
    import Vue from 'vue';

    export default {
        name: "App",
        components: {
            Chat,
            NoDragImage
        },
        data() {
            return {
                slickCheckTimeout: null,

                slick: null,
                playing: false,

                currentSlide: null,
                currentSlideText: null,
                slideCount: null,

                minSlideIndex: null,
                maxSlideIndex: null,

                slideTexts: [],

                chatOpen: false,
                chatData: null,
            }
        },
        mounted() {
            this.findSlick();
        },
        beforeMount() {
            if (window.chatBotData) {
                console.log('Using chat bot data from window.chatBotData');

                this.chatData = window.chatBotData;
            } else if (process.env.NODE_ENV === 'development') {
                console.log('Could not find window.chatBotData, but since this is the development version we are just using the fixture');

                this.chatData = require('./fixtures/chatbot/example-data.js').default;

                console.log(this.chatData);
            } else {
                console.error('Could not find window.chatBotData !!');
            }

            // Define $pling method
            if (!Vue.prototype.$pling) {
                let plingSound = new Howl({
                    src: require('@/assets/pling.mp3'),
                    autoplay: false,
                    volume: .2
                });

                Object.defineProperty(Vue.prototype, '$pling', {
                    value: function() {
                        plingSound.play();
                    }
                });
            }
        },
        methods: {
            findSlick() {
                if (this.slickCheckTimeout) {
                    clearTimeout(this.slickCheckTimeout);

                    this.slickCheckTimeout = null;
                }

                let slickElementJq = jQuery('.tdt-slider');

                if (slickElementJq.length) {
                    let slick = slickElementJq[0].slick;

                    if (slick) {
                        // We found slick! Let's attach it to our app
                        this.slick = slick;
                        this.slideCount = slick.slideCount;
                        this.currentSlide = slick.currentSlide;
                        this.minSlideIndex = 0;
                        this.maxSlideIndex = this.slideCount - 1;

                        this.slideTexts = [];

                        for (let i = 0, len = slick.$slides.length; i < len; i++) {
                            let slide = slick.$slides[i];
                            let slideContent = jQuery(slide).find('.content-section').clone();

                            // Make sure we're not looking in any header tag
                            slideContent.find('h1, h2, h3, h4, h5, h6').remove();
                            slideContent.find('.back-button-slide, .fa, .tts-ignore').remove();

                            let slideText = slideContent.text();

                            slideText = slideText.replace(/^\s+|\s+$/g, '');

                            if (slideText) {
                                //console.log(`slideText[${i}] = '${slideText}'`);

                                this.slideTexts.push(slideText);
                            } else {
                                this.slideTexts.push(null);
                            }
                        }

                        this.onSlideChange(null, this.slick, 0, 0);

                        slickElementJq.on('beforeChange', this.onSlideChange);
                    }
                }

                if (!this.slick) {
                    // Slick not yet attached.. let's check again in 100ms
                    this.slickCheckTimeout = setTimeout(this.findSlick, 100);

                    return;
                }
            },
            goBack(e) {
                this.changeSlide('previous', e);
            },
            togglePlay() {
                if (!this.currentSlideText) {
                    return;
                }

                if (this.playing) {
                    sgiTTS.stop();

                    this.playing = false;
                } else {
                    this.playing = true;

                    sgiTTS.speak(this.currentSlideText).then(() => {
                        this.playing = false;
                    });
                }
            },
            goForward(e) {
                this.changeSlide('next', e);
            },
            changeSlide(type, event) {
                let nextSlide = this.currentSlide;

                if (type === 'previous') {
                    nextSlide--;

                    if (nextSlide < this.minSlideIndex) {
                        nextSlide = this.minSlideIndex;
                    }
                } else if (type === 'next') {
                    nextSlide++;

                    if (nextSlide > this.maxSlideIndex) {
                        nextSlide = this.maxSlideIndex;
                    }
                }

                nextSlide = Math.max(0, Math.min(this.slideCount - 1, nextSlide));

                if (!event) {
                    event = new Event('click');
                }

                event.data = {
                    message: 'index',
                    index: nextSlide
                };

                this.slick.changeSlide(event);
            },
            onSlideChange(e, slick, currentSlide, nextSlide) {
                this.currentSlide = nextSlide;

            },
            openChatbot() {
                if (this.chatData) {
                    this.chatOpen = true;
                }
            }
        },
        watch: {
            chatOpen(chatOpen) {
                let headers = jQuery('.bb-header-container, .fy-header, .bbhd-overlay, #wpadminbar');
                let body = jQuery('body');

                if (chatOpen) {
                    body.css('overflow-y', 'hidden');

                    headers.hide();

                    jQuery('.wpb_wrapper').each(function() {
                    	if (!this.innerText) {
							jQuery(this).addClass('wpb_wrapper_hidden').hide();
						}
					});
                } else {
                    body.css('overflow-y', 'auto');

                    jQuery('.wpb_wrapper.wpb_wrapper_hidden').show();

                    headers.show();
                }
            },
            currentSlide(currentSlide) {
                this.playing = false;

                sgiTTS.stop();

                this.currentSlideText = this.slideTexts[currentSlide];
            }
        }
    };
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Roboto');

    @import "./styles/animations/swing/vue-transitions.scss";

    #navigator-panel {
        z-index: 99999999999999;
    }

    .navigator-panel {
        font-family: "Roboto", Arial, Helvetica, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        padding: 10px;
        line-height: 100%;

        .navigator-btn-container {
            height: 68px;
            width: 68px;
            display: inline-block;
            vertical-align: top;

            &.navigator-btn-container-center {
                margin: 0 40px;
            }

            .navigator-btn-label {
                $labelSize: 20px;

                width: 100%;
                text-align: center;
                font-size: $labelSize;
                line-height: $labelSize;
                white-space: nowrap;
                color: #000000;
            }

            &.navigator-btn-container-right {
                .navigator-btn-label {
                    position: relative;
                    left: -10px;
                }
            }
        }

        .navigator-btn {
            cursor: pointer;

            &.navigator-btn-disabled {
                opacity: .3;
                cursor: default;
            }
        }
    }

    .chat-container {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgb(220, 214, 214);
        z-index: 999999999;
        margin: 0;
        padding: 0;
        overflow-y: scroll;
    }

    .heartbeat {
        -webkit-animation: heartbeat 1.5s ease-in-out infinite both;
        animation: heartbeat 1.5s ease-in-out infinite both;
    }

    /* ----------------------------------------------
     * Generated by Animista on 2020-4-8 13:12:27
     * Licensed under FreeBSD License.
     * See http://animista.net/license for more info.
     * w: http://animista.net, t: @cssanimista
     * ---------------------------------------------- */

    /**
	 * ----------------------------------------
	 * animation heartbeat
	 * ----------------------------------------
	 */
    @-webkit-keyframes heartbeat {
        from {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: center center;
            transform-origin: center center;
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        10% {
            -webkit-transform: scale(0.91);
            transform: scale(0.91);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        17% {
            -webkit-transform: scale(0.98);
            transform: scale(0.98);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        33% {
            -webkit-transform: scale(0.87);
            transform: scale(0.87);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        45% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
    }

    @keyframes heartbeat {
        from {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transform-origin: center center;
            transform-origin: center center;
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        10% {
            -webkit-transform: scale(0.91);
            transform: scale(0.91);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        17% {
            -webkit-transform: scale(0.98);
            transform: scale(0.98);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        33% {
            -webkit-transform: scale(0.87);
            transform: scale(0.87);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        45% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
    }

    .navigator-btn-label-quiz {
        margin-left: 10px;
    }
</style>
